import { Logger } from '@sitecore-search/common';
import { getFacetConfigType } from '../utils/index.js';
class RangeFacetQueryInitializer {
    run(query, facet) {
        if ('min' in facet || 'max' in facet) {
            const { min, max, facetId } = facet;
            query
                .getRequest()
                .addSearchFacetTypeFilter(facetId, { value: min, type: 'gte' }, 'and')
                .addSearchFacetTypeFilter(facetId, { value: max, type: 'lte' }, 'and');
            return true;
        }
        Logger.error('Type range expected properties min or max to be present on the initial state for selected facets. Since none of them has been provided, initializer will not run.');
        return false;
    }
}
class ValueIdFacetQueryInitializer {
    run(query, facet) {
        if ('facetValueId' in facet) {
            const { facetId, facetValueId } = facet;
            query.getRequest().addSearchFacetTypeFilter(facetId, facetValueId);
            return true;
        }
        Logger.error('Type valueId expected property facetValueId to be present on the initial state for selected facets. Since it has not been provided, initializer will not run.');
        return false;
    }
}
class TextValueFacetQueryInitializer {
    run(query, facet) {
        if ('facetValueText' in facet) {
            const { facetId, facetValueText } = facet;
            query.getRequest().addSearchFacetTypeFilter(facetId, { value: facetValueText, type: 'eq' });
            return true;
        }
        Logger.error('Type text expected property facetValueText to be present on the initial state for selected facets. Since it has not been provided, initializer will not run.');
        return false;
    }
}
const FacetQueries = {
    range: new RangeFacetQueryInitializer(),
    valueId: new ValueIdFacetQueryInitializer(),
    text: new TextValueFacetQueryInitializer(),
};
const initializeQueries = (control) => {
    const { query, state: { selectedFacets = [] }, config = {}, } = control;
    selectedFacets.forEach((f) => {
        const type = getFacetConfigType(config, f.facetId);
        const queryInitializer = FacetQueries[type];
        if (!queryInitializer)
            return Logger.warn(`Facet type ${type} is not supported.`);
        queryInitializer.run(query, f);
    });
};
export default initializeQueries;
